import api from '../api/api';

export interface DashboardResumo {
    totalClientes: number;
    totalContratos: number;
    totalProcessos: number;
    valorTotalCausas: number;
    totalUsuarios: number;
}

export const DashboardFacade = {
    obterResumo: async (): Promise<DashboardResumo> => {
        // Agora ele usa apenas a rota final.
        // O domínio (localhost ou render) vem automaticamente do nosso api.ts!
        const response = await api.get('/api/v1/dashboard/resumo');
        return response.data;
    }
};